import React from 'react'
import { FormReadonlyField, FormSelectField } from '@/components/Form/FormField'
import { Button } from '@/components/ui/button'
import { DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { GridColumn as Column, Grid } from '@progress/kendo-react-grid'
import { TradingAccountType } from 'api/Trading-Accounts/Types/IntroducingBrokerCommissionPlanGroupDto'
import { Form, FormikProps, withFormik } from 'formik'

import { IntroducingBrokerMultiTierDetails } from '../../../api/Trading-Accounts/Types/IntroducingBrokerMultiTierDetails'
import { UpdateIntroducingBrokerMultiTierSubAccountDto } from '../../../api/Trading-Accounts/Types/UpdateIntroducingBrokerMultiTierSubAccount'
import { FormSubmitValues } from '../../../utils/formValidation'

export type UpdateIntroducingBrokerMultiTierSubAccountFormValues = Pick<
  UpdateIntroducingBrokerMultiTierSubAccountDto,
  'commissionPlanGroupId'
>
const IntroducingBrokerMTNetworkSubAccountEditFormModalUI = ({
  values,
  handleSubmit,
  isSubmitting,
  onClose,
  data,
  setFieldValue,
}: FormikProps<UpdateIntroducingBrokerMultiTierSubAccountDto> & OuterProps) => {
  const handleSaveCommission = (event?: React.SyntheticEvent) => {
    event?.preventDefault()
    handleSubmit()
  }

  return (
    <DialogContent size='lg' render={<Form onSubmit={handleSaveCommission} />}>
      <DialogHeader>
        <DialogTitle>Edit Sub-IB Profile</DialogTitle>
      </DialogHeader>
      <Grid resizable data={values.data}>
        <Column field='name' title='Profile' />
        <Column field='classic' title='Classic' />
        <Column field='vip' title='VIP' />
        <Column field='pro' title='Pro' />
        <Column field='raw' title='Raw' />
      </Grid>
      <FormReadonlyField label='Sub-IB Account' value={data.introducingBroker.name} />
      <FormSelectField
        name='commissionPlanGroupId'
        label='IB Profile'
        options={values.commissionPlans || []}
        value={values.commissionPlanGroupId}
        showSearch
        placeholder='Select Option'
        onChange={(value) => setFieldValue('commissionPlanGroupId', value)}
      />
      <DialogFooter>
        <Button disabled={isSubmitting} type='button' variant='outline' onClick={onClose}>
          Cancel
        </Button>
        <Button type='button' disabled={isSubmitting} onClick={handleSaveCommission}>
          Submit
        </Button>
      </DialogFooter>
    </DialogContent>
  )
}

interface OuterProps {
  data: IntroducingBrokerMultiTierDetails
  onSubmit(
    introducingBrokerId: string,
    values: FormSubmitValues<UpdateIntroducingBrokerMultiTierSubAccountFormValues>
  ): Promise<void>
  onClose: () => void
}

function dataToSubmit(
  values: UpdateIntroducingBrokerMultiTierSubAccountDto
): FormSubmitValues<UpdateIntroducingBrokerMultiTierSubAccountFormValues> {
  return {
    commissionPlanGroupId: values.commissionPlanGroupId,
  }
}

export const IntroducingBrokerMTNetworkSubAccountEditForm = withFormik<
  OuterProps,
  UpdateIntroducingBrokerMultiTierSubAccountDto
>({
  mapPropsToValues: (props) => {
    let data = [
      {
        name: 'Max Rebates Available',
        id: props.data.maxRebatesAvailable.id,
        vip:
          props.data.maxRebatesAvailable.commissionPlans.find(
            (x) => x.tradingAccountType.id === TradingAccountType.VIP
          )?.amount ?? 0,
        pro:
          props.data.maxRebatesAvailable.commissionPlans.find(
            (x) => x.tradingAccountType.id === TradingAccountType.Pro
          )?.amount ?? 0,
        classic:
          props.data.maxRebatesAvailable.commissionPlans.find(
            (x) => x.tradingAccountType.id === TradingAccountType.Classic
          )?.amount ?? 0,
        raw:
          props.data.maxRebatesAvailable.commissionPlans.find(
            (x) => x.tradingAccountType.id === TradingAccountType.Raw
          )?.amount ?? 0,
      },
    ]
    data = [
      ...data,
      ...props.data.allCommissionPlanGroups.map((commission) => ({
        name: commission.name,
        id: commission.id,
        vip:
          commission.commissionPlans.find(
            (plan) => plan.tradingAccountType.id === TradingAccountType.VIP
          )?.amount ?? 0,
        pro:
          commission.commissionPlans.find(
            (plan) => plan.tradingAccountType.id === TradingAccountType.Pro
          )?.amount ?? 0,
        classic:
          commission.commissionPlans.find(
            (plan) => plan.tradingAccountType.id === TradingAccountType.Classic
          )?.amount ?? 0,
        raw:
          commission.commissionPlans.find(
            (plan) => plan.tradingAccountType.id === TradingAccountType.Raw
          )?.amount ?? 0,
      })),
    ]
    return {
      data,
      commissionPlans: props.data.allCommissionPlanGroups.map((x) => ({
        id: x.id,
        name: x.name,
      })),
      commissionPlanGroupId: props.data.assignedCommissionPlanGroup.id,
    }
  },
  handleSubmit: async (values, { props }) => {
    await props.onSubmit(props.data.introducingBroker.id, dataToSubmit(values))
  },
  validate: () => {
    const errors = {}
    return errors
  },
})(IntroducingBrokerMTNetworkSubAccountEditFormModalUI)
